import { FolderAssetType } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';
import { ROOT_FOLDER_ID } from '../../../../ads-studio-app-shared-components/src/model';
import { getFolderRepository } from './folder-repository';

// simplified version of asset library folder repository for home page
export const getBasicFoldersRepository = ({
  folderODataService,
  i18n,
  ianaTimeZone,
  timezoneUTCOffset,
  perfMetricDateRange,
  logger,
}) => {
  const folderRepository = getFolderRepository({
    logger,
    folderODataService,
    i18n,
    ianaTimeZone,
    timezoneUTCOffset,
  });

  const uploadImageToFolder = ({
    imageData,
    updateCurrentProgress,
    imageName,
  }) => folderRepository.addFolderUploadAsset({
    folderId: ROOT_FOLDER_ID,
    asset: { data: imageData, name: imageName },
    folderAssetType: FolderAssetType.Image,
    inProgress: updateCurrentProgress,
  });

  const loadAssets = ({
    windowIndex, windowSize,
    withBIData = false,
    assetsToLoadForSubfolders,
    searchTerm,
    minWidth,
    minHeight,
    minVideoDuration,
    maxVideoDuration,
    dateAddedStart,
    dateAddedEnd,
    importSource,
    assetSources,
    sortBy,
    folderId = ROOT_FOLDER_ID,
    assetType = null,
    includeAssets = true,
    includeSubfolders = true,
    includeParentHierarchy = false,
    isGlobalSearch = false,
    isAssetPickerScenario = false,
    hasPerfData = false,
    topRated = false,
    isSemanticSearch = false,
    isRecentSorting = false,
  }) => {
    const top = windowSize;
    const skip = windowIndex * windowSize;
    const $ret = folderRepository.getFolderData({
      skip,
      count: top,
      withBIData,
      assetsToLoadForSubfolders,
      perfMetricDateRange,
      sortBy,
      folderId,
      assetType,
      includeAssets,
      includeSubfolders,
      includeParentHierarchy,
      isAssetPickerScenario,
      // filter settings
      assetSources,
      dateAddedStart,
      dateAddedEnd,
      hasPerfData,
      importSource,
      isGlobalSearch,
      minWidth,
      minHeight,
      minVideoDuration,
      maxVideoDuration,
      searchTerm,
      topRated,
      isSemanticSearch,
      isRecentSorting,
    }).then((response) => {
      const { folder } = response || {};
      const {
        assets,
        itemCount,
        // folderId,
        // folderName,
        // parentFolderId,
        subfolders,
        // parentHierarchy,
      } = folder || {};

      const folders = subfolders.map(subfolder =>
        ({
          folderAssetType: 'Folder',
          ...subfolder,
        }));

      return {
        assets: [...assets, ...folders],
        totalItemCount: (itemCount && itemCount.TotalCount) || 0,
      };
    });
    return $ret;
  };

  const renameAsset = ({
    assetId,
    folderAssetType,
    name,
  }) => {
    const $ret = folderRepository.renameAsset({
      assetId,
      folderAssetType,
      name,
    });
    return $ret;
  };

  return {
    loadAssets,
    renameAsset,
    uploadImageToFolder,
    updateVideoStatusByIds: folderRepository.updateVideoStatusByIds,
  };
};
